const endpoint = '/profile';

export default ['api', function (api) {
    return {
        encrypt: (profile) => {
            return api.post(`${endpoint}`, profile).then(response => response);
        },
        decrypt: (profile) => {
            return api.post(`${endpoint}`, { 'profile': profile }).then(response => response);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/services/encrypt.service.js